export default __webpack_public_path__ + "static/media/deflationary.85806779.png";